import Vue from 'vue';
export default Vue.extend({
    name: 'confirmApiKeyDeletePopupChunk',
    props: {
        slotData: {
            required: true
        }
    },
    data() {
        return {
            isValid: false,
            fields: {
                password: {
                    value: '',
                    type: 'password',
                    rules: [
                        (v) => Boolean(v.length) || this.$t('apiKeysPage.popups.errors.fieldIsRequired')
                    ]
                }
            }
        };
    },
    methods: {
        changePasswordInputType() {
            const vm = this;
            vm.fields.password.type = vm.fields.password.type === 'password' ? 'text' : 'password';
        }
    }
});
